import { createFileRoute, Link, Outlet, useMatches } from '@tanstack/react-router'
import { MaintenanceBanner } from '@/components/maintenance-banner'
import { ReferralLoginBanner } from '@/components/referral/referral-login-banner'
import { HELP_CENTER_URL } from '@/lib/constants'

export const Route = createFileRoute('/_login_forms')({
  component: AuthFormLayout,
})

function AuthFormLayout() {
  const matches = useMatches()
  const currentMatch = matches.at(-1)

  // Get title/description from current route context
  const title = (currentMatch?.context as { title: string })?.title || 'Welcome'
  const description = (currentMatch?.context as { description: string })?.description || ''

  return (
    <div className="grid w-full min-h-svh lg:grid-cols-2">
      <div className="flex flex-col p-6 md:p-10 lg:p-12">
        <div className="flex justify-center gap-2 md:justify-start">
          <a href="#" className="flex items-center gap-2 font-medium">
            <img
              src={`${import.meta.env.BASE_URL}assets/logo_with_text_side.svg`}
              alt="Supplyco Logo"
              className="h-10 w-auto object-contain md:h-12"
            />
          </a>
        </div>
        <div className="flex flex-1 items-center justify-center">
          <div className="w-full max-w-md space-y-6">
            <MaintenanceBanner />
            {/* Title and Description */}
            <div className="space-y-2">
              <h1 className="text-3xl font-bold text-gray-900 md:text-4xl">
                {title}
              </h1>
              {description && (
                <p className="text-base text-muted-foreground md:text-lg">
                  {description}
                </p>
              )}
            </div>
            <Outlet />
          </div>
        </div>
        <div className="text-center text-sm text-gray-500 mt-auto pt-6 space-y-2">
          <p>
            Need help?
            {' '}
            <a href={HELP_CENTER_URL} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
              Visit our Help Center
            </a>
          </p>
          <p>
            By signing in or creating an account, you agree to our
            {' '}
            <Link to="/terms" className="text-blue-600 hover:underline">
              Terms of Service
            </Link>
            {' '}
            and
            {' '}
            <Link to="/privacy" className="text-blue-600 hover:underline">
              Privacy Policy
            </Link>
            .
          </p>
        </div>
      </div>
      <div className="bg-muted relative hidden lg:block">
        <ReferralLoginBanner />
      </div>
    </div>
  )
}
